import React from "react";
import { chakra, SimpleGrid, useColorModeValue } from "@chakra-ui/react";
import { ImExit } from "react-icons/all";

import { useContextConsumer } from "modules/context/Providers/ContextProvider";

import { useGetFriendlyUrl } from "utils/hooks/useGetFriendlyUrl";

import { Button, CustomColorScheme } from "components/Button";
import { Icon } from "components/Icon";
import { ChakraText } from "components/ChakraText";
import { useGetThemeColors } from "ChakraTheme";
import { MainPageButton } from "components/MainPageButton";

const RedirectionButtons = () => {
  const { friendlyUrl } = useGetFriendlyUrl();
  const colors = useGetThemeColors();
  const iconColor = useColorModeValue(colors.white, colors.black);
  const { siteTitle } = useContextConsumer();

  return (
    <SimpleGrid
      my={10}
      w={{ base: "100%", md: "70%" }}
      mx="auto"
      minChildWidth="300px"
      justifyContent="center"
      spacing={4}
    >
      <MainPageButton />
      <chakra.a
        href={`${window.location.origin}/${friendlyUrl}`}
        m="auto"
        minW="200px"
        maxW={{ base: "300px", md: "500px" }}
      >
        <Button
          customColorScheme={CustomColorScheme.Blue}
          m="auto"
          minW="200px"
          maxW={{ base: "300px", md: "500px" }}
          h="70px"
          leftIcon={<Icon color={iconColor} icon={ImExit} />}
          id="redirect-to-subject-page-btn"
        >
          <ChakraText isTruncated>Przejdź do {siteTitle}</ChakraText>
        </Button>
      </chakra.a>
    </SimpleGrid>
  );
};

export { RedirectionButtons };
